interface IconTicketProps {
  active?: boolean;
  size?: number;
}

export const IconTicket = ({ active, size = 24 }: IconTicketProps) => {
  const stroke = active ? "#FF9934" : "#999999";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 6.5C4 5.94772 4.44772 5.5 5 5.5H19C19.5523 5.5 20 5.94772 20 6.5V10C18.8954 10 18 10.8954 18 12C18 13.1046 18.8954 14 20 14V17.5C20 18.0523 19.5523 18.5 19 18.5H5C4.44772 18.5 4 18.0523 4 17.5V14C5.10457 14 6 13.1046 6 12C6 10.8954 5.10457 10 4 10V6.5Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 6.5V8M14.5 10.75V13.25M14.5 16V17.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
